// login-view.js
// dashboard-view.js

import $ from 'jquery';
import { View } from 'backbone';

import contentTemplate from 'login-view.ejs';
import restService from 'RestService';
import util from 'util/Util.js';
import configService from 'ConfigService';
import constants from 'Constants';
import NotificationService from 'NotificationService.js';
import textUtil from 'util/TextUtil.js';

class LoginView extends View {

    initialize( opts ) {

        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });

        this.options = opts || {};

        $(this.el).off('submit');
        $(this.el).off('change');
        $(this.el).off('click');

        this.template = contentTemplate;
        this.events = {
            'submit #login': 'loginUser',
            'change input': 'validateForm',
            'click #backLogin': 'hideAccounts',
            'click #accountSubmit': 'loginAccount',
            'click #forgotPassword': 'forgotPassword'
            
            //'click #newUserSubmit': 'signIn'  //PF-4419. This shall be reactivated later on.
        };

        let accountsName  = {};
        this.model.set('accountsName', accountsName, {silent:true});
        this.listenTo(this.model, 'change', this.render);
        const isNewUser = window.localStorage.getItem("newUser");
        let welcomeMessage = "";
        if (isNewUser === "true") {
            welcomeMessage = "Please enter the same information you used for Sign Up.";
            window.localStorage.setItem("newUser", false);
        }

        //parameter used for set the email when comming from resetPassword link
        if (!this.model.has('e') ) {
            this.model.set('e','', {silent:true});
        }

        this.model.set('welcomeMessage', welcomeMessage, { silent: true });

       let styleCombo = 'margin: -1px 0 0 0;'
       if (textUtil.isIExplorer() || textUtil.isEdgeBrowser()) {
           styleCombo =  'margin: 0;';
       }

       this.model.set('styleCombo', styleCombo, { silent: true } );
       this.model.set('isMobileDevice', util.isMobileDevice(), constants.MODEL_SILENT);
       this.model.set('mobileMessage', constants.MESSAGE_LOGIN_ONMOBILE, constants.MODEL_SILENT);
       this.model.set('isFlashInvalidUser', false, constants.MODEL_SILENT); 

       // Log out the user
       restService.token = undefined;
       return this;
    }

    signIn(ev){
        ev.preventDefault();
        restService.getSignUpMethod().then((response)=>{
            if(response.AccountSignUpMethod === '1' && response.AccountSignUpForwardURL !== ''){
                window.location.replace(response.AccountSignUpForwardURL);
            }else{
                Backbone.history.loadUrl('sign-up');
            }
        }).catch((err)=>{
           NotificationService.error("There was an error " + err);
        });
    }

    forgotPassword(ev){
        ev.preventDefault();
        Backbone.history.loadUrl('forgotPassword');
    }

    render() {
        $(this.el).html(this.template(this.model.toJSON()));
        $(this.el).parent().addClass('blue-background');
        this.delegateEvents();
        return this;
    }

    loginAccount(e){
        e.preventDefault();
        const data = {};
        data['userName'] = !this.model.get('data')['userName']  ? $('input[name=userName]').val() : this.model.get('data')['userName'];
        data['password'] = $('#accountPassword').val();
        data['account'] = $('#accountName').val();
        data['type'] = this.model.get('data')['type'] || undefined;
        data['createLoginToken'] = this.model.get('data')['createLoginToken'] || undefined;
        const callback = ( error )=>{
            if(error){                
                $('#errorMessageAccountLabel').text(error.CODE !== "1" ? error.MESSAGE : constants.ERROR_MSG_ACCOUNT_USER_PASSWORD_NOT_RECOGNIZED);
                $('.error-message').removeClass('hide');
            } else {
                util.processSettings();  
                this.undelegateEvents(); 
                const profile = restService.getProfile();
                if (util.isTrue(profile.HtmlDashboardEnabled)){
                    Backbone.history.loadUrl('greeting');
                } else {
                    let ult;
                    if (profile.LoginToken && profile.LoginToken !== ''){
                        ult = profile.LoginToken;
                    }

                    let params = '&g=' + this.hostUrl + '&e=' + data.userName +'&c=' + $('#accountName').val();
                    if (!ult){
                        params += '&t=' + restService.getToken();
                    }
                    util.pf_main('100%', '100%', this.hostUrl+'/main.aspx', params, ult);
                }
            }
        };

        restService.login(data, callback);
    }

    loginUser(e){
        e.preventDefault();
        const inputs = $('#login').serializeArray();
        const data = {};
        $.each(inputs, function(){
            data[this.name] = this.value;
        });
        data['account'] = '';
        data['createLoginToken'] = $('#rememberMe').prop('checked');
        data['type'] = 1;
        this.model.set('data',data,{silent:true});
        const callback = ( error )=>{
            if(Array.isArray(error)){
                this.model.set('accountsName', error);        
                $("#accountName")[0].selectedIndex = 0;
                $('#accountPassword').val(data.password);
                $('input[name=userName]').val(data.userName);
                $('input[name=password]').val(data.password);
                this.showAccounts();
            }else if(error){
                if (error.CODE === constants.ERROR_CODE_TRIAL_ACCOUNT_EXPIRED){
                    restService.setEmail($('input[name=userName]').val());
                    Backbone.history.loadUrl('trialExpired');
                } else {
                    $('.error-message').removeClass('hide');
                    $('.login-text').addClass('hide');
                    $('#errorMessageLabel').text(error.MESSAGE);
                    this.model.set('errorVisibility', 'visible', constants.MODEL_SILENT);
                }
                                
                console.log(error);
            } else {                
                const profile = restService.getProfile();
                util.processSettings(); 
                this.undelegateEvents();
                if (util.isTrue(profile.HtmlDashboardEnabled)){                   
                    Backbone.history.loadUrl('greeting');
                } else {
                    if (util.isMobileDevice()) {
                        this.model.set('mobileMessage', constants.MESSAGE_FLASH_ONMOBILE, constants.MODEL_SILENT); 
                        this.model.set('isFlashInvalidUser', true, constants.MODEL_SILENT);
                        this.render();                        
                    }
                    else {
                        let ult;
                        let params = '&g=' + this.hostUrl;
                        if ($('#rememberMe').prop('checked')){
                            ult = profile.LoginToken;
                            params += '&e=' + data.userName;
                        }else{
                            params += '&t=' + restService.getToken() + '&u=' + data.userName;
                        }
                        
                        util.pf_main('100%', '100%', this.hostUrl+'/main.aspx', params, ult);
                    }                    
                }
            }
        };

        restService.login(data, callback);
    }

    hideAccounts(){
        $('#login-container').css("display", "block");
        $('#newUser-container').css("display", "block");
        $('#account-container').css("display", "none");
        $('.error-message').addClass('hide');
        $('.login-text').removeClass('hide');
    }

     showAccounts(){
        $('#login-container').css("display", "none");
        $('#newUser-container').css("display", "none");
        $('#account-container').css("display", "block");
        $("#accountPassword").on('keyup', function(event) {
            if (event.keyCode === 13) {
                $("#accountSubmit").trigger('click');
            }
        });
    }

}

export default LoginView;
